import { styled, TextField } from "@mui/material";
import React from "react";
import "../Support.scss";
import { useFormContext } from "react-hook-form";
const StyledTextField = styled(TextField)(({ theme }) => ({}));

interface CustomTextFieldProps {
  label: string;
  error: boolean;
  helperText: string;
  name: string;
  pattern ? : RegExp
}

const CustomTextField: React.FC<CustomTextFieldProps> = ({
  label,
  error,
  helperText,
  name,
  pattern
}) => {
  const {
    register,
  } = useFormContext();

  const handleInput = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;

    // If a pattern prop is provided, restrict input to 10 digits
    if (pattern) {
      e.target.value = value.replace(/\s+/g, ""); // Remove non-digit characters
    }
  };
  
  return (
    <div style={{ height: 50 }} className="customTextFieldStyle">
      <StyledTextField
        error={error}
        {...register(name)}
        id="standard-error-helper-text"
        helperText={helperText}
        variant="standard"
        label={label}
        fullWidth
        onInput={handleInput}
        InputProps={{
          sx: {
            fontSize: "14px",
            color: "#1D1D1D",
            fontFamily: "Inter",
            paddingBottom: "3px",
          },
        }}
        InputLabelProps={{
          shrink: true,
          sx: {
            fontSize: "14px",
            fontFamily: "Inter",
            fontWeight: "400",
            color: "#969696",
            "&.Mui-focused": {
              color: "#969696", // Keep label color fixed when focused
            },
            "&.Mui-error": {
              color: "#969696", // Keep label color the same when error occurs
            },
          },
        }}
        sx={{
          "& .MuiInput-underline:before": {
            borderBottomColor: "#ccc", // Default underline color
          },
          "& .MuiInput-underline:hover:not(.Mui-disabled):before": {
            borderBottomColor: "#ccc", // Underline color on hover
          },
          "& .MuiInput-underline:after": {
            borderBottomColor: "transparent", // Remove blue underline on focus
          },
          "& .MuiFormHelperText-root.Mui-error": {
            color: "red", // Change this to your preferred color
          },
        }}
      />
    </div>
  );
};

export default CustomTextField;
